// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"style_IconButton__vL2S_","IconImage":"style_IconImage__3yD2p"};